// extracted by mini-css-extract-plugin
export default {"defaultCard":"ho-z","otherCards":"io-z","empty":"jo-z","addNewItem":"ko-z","disabled":"lo-z","cardGrid":"mo-z"};